import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalCloseService } from 'src/services/modal-close.service';

@Component({
  selector: 'app-session-timeout-modal',
  templateUrl: './session-timeout-modal.component.html',
  styleUrls: ['./session-timeout-modal.component.scss']
})
export class SessionTimeoutModalComponent {

  constructor( private router : Router,
    private sessionModalService: ModalCloseService) { }

    closeModalAndRedirect() {
      localStorage.removeItem('token');
      localStorage.clear();
      localStorage.setItem('guardFlag', "true");
      this.router.navigateByUrl('login');
      this.sessionModalService.updateShowModal(false);
    }

}
